import { Fixtures } from "./components/Fixtures";
import { Matches } from "./components/Matches";
import { Results } from "./components/Results";
import { Standings } from "./components/Standings";
import { Statistics } from "./components/Statistics";
import { MatchDetails } from "./components/MatchDetails";
import { InfoMatches } from "./components/sharedComponents/InfoMatches";
import { PortalMatches } from "./components/sharedComponents/PortalMatches";
import { RoysniMatches } from "./components/sharedComponents/RoysniMatches";
import { FM1Matches } from "./components/sharedComponents/FM1Matches";
import { StandingsShared } from "./components/sharedComponents/StandingsShared";
import { StripPayment } from "./components/payments/StripPayment";
import { ReturnPayment } from "./components/payments/ReturnPayment";

const AppRoutes = [
    {
        index: true,
        element: <Matches />
    },
    {
        path: '/matches/*',
        element: <Matches />
    },
    {
        path: '/results',
        element: <Results />
    },
    {
        path: '/results/*',
        element: <Results />
    },
    {
        path: '/fixtures',
        element: <Fixtures />
    },
    {
        path: '/fixtures/*',
        element: <Fixtures />
    },
    {
        path: '/standings',
        element: <Standings />
    },
    {
        path: '/standings/*',
        element: <Standings />
    },
    {
        path: '/statistics',
        element: <Statistics />
    },
    {
        path: '/statistics/*',
        element: <Statistics />
    },
    {
        path: '/matchDetails/*',
        element: <MatchDetails />
    },
    {
        path: '/info/matches',
        element: <InfoMatches />
    },
    {
        path: '/info/todaymatches',
        element: <InfoMatches />
    },
    {
        path: '/portal/matches',
        element: <PortalMatches />
    },
    {
        path: '/roysni/matches',
        element: <RoysniMatches />
    },
    {
        path: '/roysni/standings',
        element: <StandingsShared />
    },
    {
        path: '/fm1/matches',
        element: <FM1Matches />
    },
    {
        path: '/fm1/standings',
        element: <StandingsShared />
    },
    {
        path: '/info/matchdetails/*',
        element: <MatchDetails />
    },
    {
        path: '/portal/matchdetails/*',
        element: <MatchDetails />
    },
    {
        path: '/roysni/matchdetails/*',
        element: <MatchDetails />
    },
    {
        path: '/fm1/matchdetails/*',
        element: <MatchDetails />
    },
    {
        path: '/football/*',
        element: <Matches />
    },
    {
        path: '/payments/*',
        element: <StripPayment />
    },
    {
        path: '/return',
        element: <ReturnPayment />
    },
];

export default AppRoutes;
